import { render } from "./EditItem.vue?vue&type=template&id=718da010&scoped=true"
import script from "./EditItem.vue?vue&type=script&lang=ts"
export * from "./EditItem.vue?vue&type=script&lang=ts"

import "./EditItem.vue?vue&type=style&index=0&id=718da010&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-718da010"

export default script